var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "custom-payment-wrapper" }, [
    _c("div", { staticClass: "page-wrapper" }, [
      _vm._m(0),
      _vm._v(" "),
      _vm.remark == "success"
        ? _c("div", { staticClass: "success-shell" }, [
            _c("div", { staticClass: "success-card" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("h2", [_vm._v("Payment Successful")]),
              _vm._v(" "),
              _c("p", [
                _vm._v("Your payment has been confirmed successfully.")
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn action-btn print-success-btn",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.handleClick(2)
                    }
                  }
                },
                [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("span", [_vm._v("Print Invoice")]),
                  _vm._v(" "),
                  _c("i", { staticClass: "fa-solid fa-angle-right" })
                ]
              )
            ])
          ])
        : _c("main", { staticClass: "content-grid" }, [
            _c("section", { staticClass: "main-card" }, [
              _c(
                "form",
                {
                  attrs: { id: "registerform" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                    },
                    keydown: function($event) {
                      return _vm.paymentForm.errors.clear($event.target.name)
                    }
                  }
                },
                [
                  _vm._m(3),
                  _vm._v(" "),
                  _c("hr", { staticClass: "divider" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "section-block" }, [
                    _vm._m(4),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-grid" }, [
                      _c("div", { staticClass: "info-card" }, [
                        _vm._m(5),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-text" }, [
                          _c("span", [_vm._v("Payer Name")]),
                          _vm._v(" "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.paymentForm.name || "-"))
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-card" }, [
                        _vm._m(6),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-text" }, [
                          _c("span", [_vm._v("Payer Email")]),
                          _vm._v(" "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.paymentForm.email || "-"))
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-card" }, [
                        _vm._m(7),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-text" }, [
                          _c("span", [_vm._v("Payer Number")]),
                          _vm._v(" "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.paymentForm.phone || "-"))
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "section-block" }, [
                    _vm._m(8),
                    _vm._v(" "),
                    _c("div", { staticClass: "details-box" }, [
                      _c("div", { staticClass: "details-item" }, [
                        _c("span", [_vm._v("Payment MDA")]),
                        _vm._v(" "),
                        _c("strong", [_vm._v(_vm._s(_vm.mda || "-"))])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "details-divider" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "details-item" }, [
                        _c("span", [_vm._v("Payment Description")]),
                        _vm._v(" "),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.pay_item || _vm.description || "-"))
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "amount-box" }, [
                    _vm._m(9),
                    _vm._v(" "),
                    _c("div", { staticClass: "amount-value" }, [
                      _vm._v(
                        _vm._s(_vm._f("formatMoney")(_vm.paymentForm.amount))
                      )
                    ])
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "aside",
              { staticClass: "sidebar-card" },
              [
                _c("div", { staticClass: "invoice-box" }, [
                  _vm._m(10),
                  _vm._v(" "),
                  _c("div", { staticClass: "invoice-text" }, [
                    _c("span", [_vm._v("Invoice Number")]),
                    _vm._v(" "),
                    _c("h3", [_vm._v(_vm._s(_vm.paymentForm.invoice_no))])
                  ])
                ]),
                _vm._v(" "),
                _c("hr", { staticClass: "divider" }),
                _vm._v(" "),
                _vm.trx
                  ? [
                      _c("div", { staticClass: "transfer-section" }, [
                        _vm._m(11),
                        _vm._v(" "),
                        _c("div", { staticClass: "transfer-card" }, [
                          _c("div", { staticClass: "bank-row" }, [
                            _c("span", [_vm._v("Bank Name:")]),
                            _vm._v(" "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.paymentForm.bank_name
                                    ? _vm.paymentForm.bank_name
                                        .replace(/Bank$/i, "")
                                        .trim()
                                    : "-"
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "bank-row" }, [
                            _c("span", [_vm._v("Account No:")]),
                            _vm._v(" "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.paymentForm.account_number || "-")
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "bank-row" }, [
                            _c("span", [_vm._v("Account Name:")]),
                            _vm._v(" "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.paymentForm.account_name || "-")
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "bank-row" }, [
                            _c("span", [_vm._v("Amount:")]),
                            _vm._v(" "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatMoney")(_vm.paymentForm.amount)
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn transfer-btn",
                              style: {
                                background:
                                  "linear-gradient(90deg, #03572c, #0b6f38)",
                                color: "#ffffff"
                              },
                              attrs: {
                                disabled: _vm.iHavePaidLoading,
                                type: "button"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.iHavePaid()
                                }
                              }
                            },
                            [
                              _vm.iHavePaidLoading
                                ? [
                                    _c("i", {
                                      staticClass: "fa-solid fa-spinner fa-spin"
                                    }),
                                    _vm._v(
                                      "\n                                    Checking Payment...\n                                "
                                    )
                                  ]
                                : [
                                    _c("i", {
                                      staticClass: "fa-regular fa-circle-check"
                                    }),
                                    _vm._v(
                                      "\n                                    I Have Transferred\n                                "
                                    )
                                  ]
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "expire-note" },
                            [
                              _vm.timeLeft.total > 0
                                ? [
                                    _c("i", {
                                      staticClass: "fa-regular fa-clock"
                                    }),
                                    _vm._v(
                                      "\n                                    This one-time account expires in "
                                    ),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.timeLeft.hours) +
                                          "h " +
                                          _vm._s(_vm.timeLeft.minutes) +
                                          "m " +
                                          _vm._s(_vm.timeLeft.seconds) +
                                          "s"
                                      )
                                    ])
                                  ]
                                : [
                                    _c("i", {
                                      staticClass: "fa-regular fa-clock"
                                    }),
                                    _vm._v(
                                      "\n                                    This one-time account has expired.\n                                "
                                    )
                                  ]
                            ],
                            2
                          )
                        ])
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "gateway-section" }, [
                  _c("div", { staticClass: "or-pay" }, [
                    _vm._v("OR PAY ONLINE")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "gateway-grid" }, [
                    _c(
                      "button",
                      {
                        class: [
                          "gateway-card",
                          {
                            active: _vm.selectedGateway === 4,
                            loading:
                              _vm.paymentForm.isLoading &&
                              _vm.selectedGateway === 4
                          }
                        ],
                        attrs: {
                          disabled: _vm.paymentForm.isLoading,
                          type: "button"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleClick(4)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "gateway-logo" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                viewBox: "0 0 64 64",
                                "aria-hidden": "true"
                              }
                            },
                            [
                              _c("rect", {
                                attrs: {
                                  width: "64",
                                  height: "64",
                                  rx: "13",
                                  fill: "#07334a"
                                }
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d:
                                    "M16 28c9-2 22-3 29-2 4 .6 5.3 4.1 3 7.2L26 55l10.4-22.5c.8-1.8-.3-3.3-2.3-3.2L16 28z",
                                  fill: "#ef1b2d"
                                }
                              }),
                              _vm._v(" "),
                              _c("circle", {
                                attrs: {
                                  cx: "47",
                                  cy: "19",
                                  r: "7",
                                  fill: "#ef1b2d"
                                }
                              })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.paymentForm.isLoading &&
                                _vm.selectedGateway === 4
                                ? "Processing..."
                                : "Interswitch"
                            )
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.trx
                      ? _c(
                          "button",
                          {
                            class: [
                              "gateway-card",
                              "gateway-card-monnify",
                              {
                                active: _vm.selectedGateway === 3,
                                loading: _vm.paymentForm.isMonnifyLoading
                              }
                            ],
                            attrs: {
                              disabled: _vm.paymentForm.isMonnifyLoading,
                              type: "button"
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleClick(3)
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "gateway-logo" }, [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    viewBox: "0 0 64 64",
                                    "aria-hidden": "true"
                                  }
                                },
                                [
                                  _c("circle", {
                                    attrs: {
                                      cx: "16",
                                      cy: "39",
                                      r: "8",
                                      fill: "#f7941d"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("circle", {
                                    attrs: {
                                      cx: "48",
                                      cy: "39",
                                      r: "8",
                                      fill: "#f6c215"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("circle", {
                                    attrs: {
                                      cx: "25",
                                      cy: "24",
                                      r: "8",
                                      fill: "#02b3ad"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("circle", {
                                    attrs: {
                                      cx: "39",
                                      cy: "24",
                                      r: "8",
                                      fill: "#02b3ad"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M24 28c2 8 6 13 8 13s6-5 8-13",
                                      fill: "none",
                                      stroke: "#02b3ad",
                                      "stroke-width": "12",
                                      "stroke-linecap": "round"
                                    }
                                  })
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.paymentForm.isMonnifyLoading
                                    ? "Processing..."
                                    : "Monnify"
                                )
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        class: [
                          "gateway-card",
                          {
                            active: _vm.selectedGateway === 1,
                            loading:
                              _vm.paymentForm.isLoading &&
                              _vm.selectedGateway === 1
                          }
                        ],
                        attrs: {
                          disabled: _vm.paymentForm.isLoading,
                          type: "button"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleClick(1)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "gateway-logo" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                viewBox: "0 0 64 64",
                                "aria-hidden": "true"
                              }
                            },
                            [
                              _c("circle", {
                                attrs: {
                                  cx: "32",
                                  cy: "32",
                                  r: "29",
                                  fill: "#f15a24"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "text",
                                {
                                  attrs: {
                                    x: "24",
                                    y: "42",
                                    "font-size": "34",
                                    "font-weight": "700",
                                    "font-family": "Arial, sans-serif",
                                    fill: "#fff"
                                  }
                                },
                                [_vm._v("r")]
                              ),
                              _vm._v(" "),
                              _c("circle", {
                                attrs: {
                                  cx: "44",
                                  cy: "40",
                                  r: "4",
                                  fill: "#00a887"
                                }
                              })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.paymentForm.isLoading &&
                                _vm.selectedGateway === 1
                                ? "Processing..."
                                : "Remita"
                            )
                          )
                        ])
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn print-btn",
                    attrs: {
                      disabled: _vm.paymentForm.isPrintLoading,
                      type: "button"
                    },
                    on: {
                      click: function($event) {
                        return _vm.handleClick(2)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fa-solid fa-print" }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.paymentForm.isPrintLoading
                            ? "Preparing..."
                            : "Print Invoice"
                        ) +
                        "\n                "
                    )
                  ]
                )
              ],
              2
            )
          ]),
      _vm._v(" "),
      _vm._m(12)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "top-header" }, [
      _c("div", { staticClass: "brand-area" }, [
        _c("div", { staticClass: "logo-circle" }, [
          _c("img", {
            staticClass: "soimg",
            attrs: { src: "/../images/logo/logox.png", alt: "SOIRS Logo" }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "brand-text" }, [
          _c("h1", [_vm._v("Sokoto State Internal Revenue Service")]),
          _vm._v(" "),
          _c("p", [
            _c("i", { staticClass: "fa-solid fa-location-dot" }),
            _vm._v(" No. 4 Kano Road, Investment House Sokoto,")
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("Sokoto State, Nigeria")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "secure-box" }, [
        _c("div", { staticClass: "secure-icon" }, [
          _c("i", { staticClass: "fa-solid fa-shield-halved" })
        ]),
        _vm._v(" "),
        _c("div", [
          _c("h3", [_vm._v("Secure Payment")]),
          _vm._v(" "),
          _c("p", [_vm._v("Your payment is safe and encrypted")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "success-icon-wrap" }, [
      _c("img", {
        staticClass: "success-image",
        attrs: {
          src: "/../images/success.svg",
          alt: "Success",
          width: "100",
          height: "44"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "btn-left" }, [
      _c("i", { staticClass: "fa-solid fa-print" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-intro" }, [
      _c("div", { staticClass: "intro-icon" }, [
        _c("i", { staticClass: "fa-regular fa-file-lines" })
      ]),
      _vm._v(" "),
      _c("div", [
        _c("h2", [_vm._v("Payment Request")]),
        _vm._v(" "),
        _c("p", [
          _vm._v("Please review the details below and complete your payment.")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "section-title" }, [
      _c("i", { staticClass: "fa-regular fa-user" }),
      _vm._v(
        "\n                            Payer Information\n                        "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-icon" }, [
      _c("i", { staticClass: "fa-regular fa-user" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-icon" }, [
      _c("i", { staticClass: "fa-regular fa-envelope" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-icon" }, [
      _c("i", { staticClass: "fa-solid fa-phone" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "section-title" }, [
      _c("i", { staticClass: "fa-regular fa-file-lines" }),
      _vm._v(
        "\n                            Payment Details\n                        "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "amount-left" }, [
      _c("div", { staticClass: "amount-icon" }, [
        _c("i", { staticClass: "fa-regular fa-credit-card" })
      ]),
      _vm._v(" "),
      _c("span", [_vm._v("Total Amount Payable")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "invoice-icon" }, [
      _c("i", { staticClass: "fa-regular fa-file-lines" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "section-title green" }, [
      _c("i", { staticClass: "fa-solid fa-building-columns" }),
      _vm._v(
        "\n                            PAY WITH TRANSFER\n                        "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("footer", { staticClass: "footer-note" }, [
      _c("p", [
        _c("i", { staticClass: "fa-solid fa-shield-halved" }),
        _vm._v(
          " SOIRS is committed to protecting your data and ensuring secure transactions."
        )
      ]),
      _vm._v(" "),
      _c("small", [
        _vm._v(
          "© 2024 Sokoto State Internal Revenue Service. All rights reserved."
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }